import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'
import { scaleDownIn, rightRollIn } from './animations'

const { Decorator } = common

export const Container = styled.div`
  position: relative;
  height: 100%;
`

export type AnimatedDecoratorProps = {
  animated?: boolean
}

export const AnimatedDecorator = styled(Decorator)<AnimatedDecoratorProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;

  ${({ animated }) => animated && scaleDownIn}
`

export const LogoShape = styled.img<AnimatedDecoratorProps>`
  position: absolute;
  width: 740px;
  bottom: -280px;
  right: -385px;
  z-index: 0;
  user-select: none;

  ${media.lg`
    width: 900px;
    bottom: -370px;
    right: -400px;
  `}

  ${media.xl`
    width: 1090px;
    bottom: -530px;
    right: -370px;
  `}

  ${({ animated }) => animated && rightRollIn};
`
